import { BaseModel } from '@kinet-open-network/client/shared/data-access/model';
import {
  AbilitySubjectType,
  IInvoiceClosure,
  IInvoiceItem,
} from '@kinet-open-network/shared/data-access/model';
import { Type } from 'class-transformer';

export class Closure
  extends BaseModel<Closure, 'Closure'>
  implements IInvoiceClosure
{
  static override readonly modelName: AbilitySubjectType = 'Closure';

  @Type(() => Date)
  period!: Date;
  internalId!: string;
  description?: string | null;
  externalId?: string | null;
  items: IInvoiceItem[] = [];
}
